<script lang="ts" setup>
const jackpots = ref([]);
const currentIndex = ref(0);
let rotation: ReturnType<typeof setInterval> | undefined;
const handleUpdate = (event: Event) => {
  const next = (event as CustomEvent).detail;
  jackpots.value = Array.isArray(next) ? next : [];
  // The old index may no longer exist when the SDK sends a shorter list.
  currentIndex.value = 0;
};
onMounted(() => {
  window.addEventListener('jackpot-update', handleUpdate);
  rotation = setInterval(() => {
    if (jackpots.value.length === 0) return;
    currentIndex.value = (currentIndex.value + 1) % jackpots.value.length;
  }, 5000);
});
onUnmounted(() => {
  window.removeEventListener('jackpot-update', handleUpdate);
  clearInterval(rotation);
});

const currentJackpot = computed(() => {
  if (jackpots.value.length === 0) return undefined;
  return jackpots.value[currentIndex.value];
});

const formatCurrency = (amount?: string, currencyCode: string = 'EUR') => {
  if (!amount) {
    return '';
  }
  const locale = navigator.language || 'en-US';
  const _amount = parseFloat(amount ?? '0');
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
  }).format(_amount);
};

// { "ID": "01JZ5QJ2Z71WY3B8KT65SEQ59H", "Name": "Maxi", "Description": "this is the medium tier", "CurrencyCode": "EUR", "Balance": "8.25", "LogoURL": "https://demo-admin.ft-crm.com/media-api/serve/11e0e925-7c6a-486c-bb36-af924eabafec_Screenshot_2023-07-03_at_11.26.20.png", "GroupInfo": { "ID": "01JZ34PTGWRD5S251TGVZRDEHD", "Name": "Jonis test jackpot", "Description": "This is a new bonus that is correctly setup", "LogoURL": "https://demo-admin.ft-crm.com/media-api/serve/dee21423-b0c1-4ade-9119-3fbfd31cff65_jackpot-iamge.jpeg" } }

</script>
<template>
  <div class="jackpot" v-if="currentJackpot">
    <div class="">
      <img :src="currentJackpot.LogoURL" alt="Jackpot Logo" class="jackpot__image" />
    </div>
    <div>
      <div class="jackpot__name">
        {{ currentJackpot.Name }}
      </div>
      <div class="jackpot__balance">
        {{ formatCurrency(currentJackpot.Balance, currentJackpot.CurrencyCode) }}
      </div>
    </div>
  </div>
</template>
<style scoped>
.jackpot {
  display: flex;
  gap: 8px;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  padding: 4px 8px;
  border-radius: 4px;
}

.jackpot__image {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.jackpot__name {
  font-size: 12px;
  line-height: 1;
}

.jackpot__balance {
  font-weight: 700;
  line-height: 1;
}
</style>